import React from 'react';
import { LockKeyholeIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section className="bg-brand-main px-4 py-20" data-id="element-79" data-mp="4vs1604r2hrx">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-80" data-mp="9umi0wj5pw9e">
        <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full bg-brand-alt shadow-sm" data-id="element-81" data-mp="9t1lx2h7259f">
          <LockKeyholeIcon className="h-8 w-8 text-brand-orange" aria-hidden="true" data-id="element-82" data-mp="er35doij86lf" />
        </div>
        <h2 className="text-2xl font-extrabold text-brand-navy md:text-3xl" data-id="element-83" data-mp="ntm4bxj75z2e">
          Geld zurück oder behalten.
        </h2>
        <p className="mt-5 leading-relaxed text-brand-gray" data-id="element-84" data-mp="sm5jv01g349u">
          Teste Kunst Startklar 30 Tage risikofrei. Wenn es deinen Unterricht
          nicht leichter macht, bekommst du dein Geld zurück — ohne Fragen. Und
          du darfst alles behalten.
        </p>
      </Reveal>
    </section>;
}